(() => {
  'use strict';
  if (window.MoonStarStackPreview) return;
  const cache = new Map();
  const mounted = new Map();
  function measure(src) {
    let url;
    try { url = new URL(src, location.href); if (!['https:', 'http:'].includes(url.protocol)) return Promise.resolve(null); }
    catch { return Promise.resolve(null); }
    if (/\/cdn\/shop\//.test(url.pathname) || url.hostname === 'cdn.shopify.com') url.searchParams.set('width', '240');
    const key = url.href;
    if (!cache.has(key)) cache.set(key, new Promise(resolve => {
      const image = new Image();
      let timer;
      const finish = value => { clearTimeout(timer); image.onload = image.onerror = null; resolve(value); };
      image.crossOrigin = 'anonymous';
      image.onerror = () => finish(null);
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = 192; canvas.height = Math.max(1, Math.round(192 * image.naturalHeight / image.naturalWidth));
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
          let left = canvas.width, right = -1, top = canvas.height, bottom = -1;
          for (let y = 0; y < canvas.height; y++) for (let x = 0; x < canvas.width; x++) if (pixels[(y * canvas.width + x) * 4 + 3] > 20) {
            left = Math.min(left, x); right = Math.max(right, x); top = Math.min(top, y); bottom = Math.max(bottom, y);
          }
          finish(right < 0 ? null : { x: left / canvas.width, y: top / canvas.width, w: (right - left + 1) / canvas.width, h: (bottom - top + 1) / canvas.width });
        } catch { finish(null); }
      };
      timer = setTimeout(() => finish(null), 8000);
      image.src = key;
    }));
    return cache.get(key);
  }
  function layout(boxes, width, height) {
    if (!boxes.length || width <= 0 || height <= 0) return { height: Math.max(0, height), items: [] };
    let offset = 0, right = 0;
    const positions = boxes.map(box => {
      const left = offset, aspect = box.w / box.h;
      right = Math.max(right, left + aspect);
      offset += aspect * .52;
      return left;
    });
    const inset = Math.min(width * .1, Math.max(16, width * .045));
    const visibleHeight = Math.min(Math.max(1, width - 2 * inset) / right, height * .9, width * .55, 320);
    const origin = (width - right * visibleHeight) / 2;
    return { height, items: boxes.map((box, i) => {
      const scale = visibleHeight / box.h;
      return { width: scale, left: origin + positions[i] * visibleHeight - box.x * scale, top: (height - visibleHeight) / 2 - box.y * scale };
    }) };
  }
  function successBounds(width,height,imageWidth=1483,imageHeight=1282,cover=true) {
    const scale=(cover?Math.max:Math.min)(width/imageWidth,height/imageHeight);
    const drawnWidth=imageWidth*scale,drawnHeight=imageHeight*scale;
    return {left:(width-drawnWidth)/2+drawnWidth*.29,top:drawnHeight*.17,width:drawnWidth*.40,height:drawnHeight*.265};
  }
  function mount(stage) {
    if (mounted.has(stage)) return;
    const success = stage.hasAttribute('data-moonstar-stack-success');
    const panel = stage.parentElement;
    const successFrame = success ? panel.parentElement : null;
    const computer = successFrame?.querySelector('[data-moonstar-success-computer]');
    const summary = panel.querySelector('[data-moonstar-stack-summary]');
    const logo = panel.querySelector('[data-moonstar-stack-logo]');
    const badge = [...panel.children].find(e => e.getAttribute('x-show') === 'badgePercentage > 0');
    let frame = 0, revision = 0;
    stage.setAttribute('data-preview-managed', '');
    const stageStyles = success
      ? { position: 'relative', left: 'auto', right: 'auto', width: '90%', 'max-width': '540px', height: 'clamp(80px,14svh,120px)', margin: '0px', 'flex-shrink': '0', 'align-self': 'center' }
      : { position: 'absolute', left: '0px', right: '0px', width: '100%' };
    for (const [property, value] of Object.entries(stageStyles)) stage.style.setProperty(property, value, 'important');
    const wrappers = () => [...stage.children].filter(e => e.matches('[data-moonstar-stack-item]'));
    const schedule = (records = []) => {
      for (const record of records) if (record.attributeName === 'src') record.target.closest('[data-moonstar-stack-item]')?.removeAttribute('data-preview-ready');
      for (const item of wrappers()) if (!item.hasAttribute('data-preview-ready')) {
        item.style.setProperty('visibility', 'hidden', 'important');
        item.style.setProperty('position', 'absolute', 'important');
        item.style.setProperty('margin-left', '0px', 'important');
      }
      revision++; cancelAnimationFrame(frame); frame = requestAnimationFrame(update);
    };
    function fitSuccessPanel() {
      if (!computer || !successFrame.clientWidth || !successFrame.clientHeight) return;
      const imageStyle=getComputedStyle(computer),phone=imageStyle.display==='none';
      const bounds=phone
        ? {left:16,top:16,width:Math.max(1,successFrame.clientWidth-32),height:Math.max(1,successFrame.clientHeight-32)}
        : successBounds(successFrame.clientWidth,successFrame.clientHeight,computer.naturalWidth||1483,computer.naturalHeight||1282,imageStyle.objectFit==='cover');
      const properties={left:bounds.left+'px',top:bounds.top+'px',width:bounds.width+'px',height:bounds.height+'px',right:'auto',bottom:'auto',translate:'none',transform:'none',display:'grid','grid-template-columns':'minmax(0,1fr)','grid-template-rows':phone?'minmax(0,min(28svh,180px))':'minmax(0,1fr)','grid-auto-rows':'auto','align-content':phone?'center':'stretch','align-items':'center','justify-items':'center',gap:Math.max(4,Math.min(10,bounds.height*.025))+'px',overflow:phone?'auto':'visible','box-sizing':'border-box'};
      for (const [property,value] of Object.entries(properties)) panel.style.setProperty(property,value,'important');
      for (const [property,value] of Object.entries({width:'100%','max-width':'100%',height:'100%','min-height':'0px','align-self':'stretch'})) stage.style.setProperty(property,value,'important');
      const upsell=panel.querySelector('[data-moonstar-success-upsell]');
      if (upsell) upsell.style.setProperty('margin','0px','important');
    }
    function area() {
      if (success) { fitSuccessPanel(); return { top: 0, height: stage.clientHeight, width: stage.clientWidth }; }
      const base = panel.getBoundingClientRect().top + panel.clientTop;
      let top = 8;
      for (const element of [logo, badge]) {
        const rect = element?.getBoundingClientRect();
        if (rect?.height > 0 && rect.width > 0) top = Math.max(top, rect.bottom - base + 8);
      }
      const footer = summary?.firstElementChild?.getBoundingClientRect();
      const bottom = Math.min(panel.clientHeight - 8, footer?.height > 0 ? footer.top - base - 8 : panel.clientHeight - 8);
      top = Math.max(0, Math.min(top, bottom - 1));
      return { top, height: Math.max(1, bottom - top), width: panel.clientWidth };
    }
    async function update() {
      const version = revision, items = wrappers(), space = area();
      if (!items.length) { if (!success) stage.style.height = '0px'; stage.removeAttribute('data-spacing-ready'); return; }
      if (!space.width || panel.clientHeight <= 0) return;
      const sources = items.map(e => e.querySelector('img')?.getAttribute('src'));
      const measured = await Promise.all(sources.map(src => src ? measure(src) : null));
      if (version !== revision || !stage.isConnected || items.some((item, i) => !item.isConnected || item.querySelector('img')?.getAttribute('src') !== sources[i])) return;
      const boxes = measured.map((box, i) => {
        if (box) return box;
        const image = items[i].querySelector('img');
        const ratio = (Number(image?.getAttribute('height')) || 1158) / (Number(image?.getAttribute('width')) || 1000);
        return { x: .2, y: ratio * .1, w: .6, h: ratio * .8 };
      });
      const result = layout(boxes, space.width, space.height);
      if (!success) { stage.style.height = result.height + 'px'; stage.style.top = space.top + 'px'; }
      stage.dataset.spacingReady = '';
      items.forEach((item, i) => {
        const box = result.items[i];
        for (const [property, value] of Object.entries({ position: 'absolute', 'margin-left': '0px', translate: 'none', transform: 'none', 'transition-property': 'opacity' })) item.style.setProperty(property, value, 'important');
        for (const property of ['width', 'left', 'top']) item.style.setProperty(property, box[property] + 'px', 'important');
        item.setAttribute('data-preview-ready', '');
        item.style.setProperty('visibility', 'visible', 'important');
      });
    }
    const observer = new MutationObserver(schedule);
    observer.observe(stage, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    const resize = new ResizeObserver(() => schedule());
    for (const element of success ? [stage, successFrame, ...panel.children] : [panel, summary, logo, badge]) if (element) resize.observe(element);
    const onResize = () => schedule();
    window.addEventListener('resize', onResize, { passive: true });
    computer?.addEventListener('load',onResize);
    document.fonts?.ready.then(onResize);
    mounted.set(stage, () => {
      revision++; cancelAnimationFrame(frame); observer.disconnect(); resize.disconnect(); window.removeEventListener('resize', onResize);
      computer?.removeEventListener('load',onResize);
      if (computer) { for (const property of ['left','top','width','height','right','bottom','translate','transform','display','grid-template-columns','grid-template-rows','grid-auto-rows','align-content','align-items','justify-items','gap','overflow','box-sizing']) panel.style.removeProperty(property); panel.querySelector('[data-moonstar-success-upsell]')?.style.removeProperty('margin'); }
      stage.removeAttribute('data-preview-managed'); stage.removeAttribute('data-spacing-ready');
      ['height', 'top', 'min-height', ...Object.keys(stageStyles)].forEach(p => stage.style.removeProperty(p));
      wrappers().forEach(e => { e.removeAttribute('data-preview-ready'); ['left', 'top', 'width', 'position', 'margin-left', 'visibility', 'translate', 'transform', 'transition-property'].forEach(p => e.style.removeProperty(p)); });
    });
    schedule();
  }
  function scan() { document.querySelectorAll('[data-moonstar-stack-stage]').forEach(mount); }
  window.MoonStarStackPreview = { layout, successBounds };
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => { for (const [stage, destroy] of mounted) if (event.target.contains(stage)) { destroy(); mounted.delete(stage); } });
  scan();
})();
